
























































import { Component, Vue } from "vue-property-decorator";
import { RawLocation }    from "vue-router";

@Component({
      components: {}
  })
  export default class Manage extends Vue {
      items: { title: string; icon: string; to: RawLocation }[] = [
          {title: "Home", icon: "home", to: {name: "Home"}},
          {title: "Login", icon: "account_box", to: {name: "Login"}},
          {title: "Unite", icon: "people_outline", to: {name: "UnitePage", params: {id: "1"}}}
      ];

      show          = true;

  }
